@if (mail) {
  <div class="mail-view">
    <wm-mailcontent-artifact [artifact]="mail"></wm-mailcontent-artifact>
  </div>
} @else {
  <p>No mail data available.</p>
}
